import gql from 'graphql-tag';

export const DEBUG_PATIENT = gql`
  query PatientDebug($q: String!) {
    patientDebug(q: $q) {
      errorLink
    }
  }
`;
